import React from "react";

import { getSkeletonPercentageWidthByIndex, Skeleton } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { PlaceholderComponent } from "../../types";
import { COMMON_CONTENT_SKELETON_HEIGHT } from "./constants";

const classNames = bemClassNames("lite-list-frame-skeleton-attribute-placeholder");

export const LiteListFrameSkeletonAttributePlaceholder: PlaceholderComponent = ({
    attributeIndex = 0,
}) => (
    <div className={classNames()}>
        <Skeleton
            height={COMMON_CONTENT_SKELETON_HEIGHT}
            width={getSkeletonPercentageWidthByIndex(attributeIndex)}
        />
    </div>
);
